import { PAGE_SIZES } from '@hr/shared';
import { z } from 'zod';
import type { ServerTableState } from '@/components/data-table';

/**
 * Параметри списку в URL. Усі необов'язкові й «прощають» сміття (`.catch`),
 * щоб зіпсоване посилання відкривало список з типовими налаштуваннями, а не помилку.
 */
export const listSearchShape = {
  page: z.number().int().min(1).optional().catch(undefined),
  size: z
    .number()
    .int()
    .refine((n) => (PAGE_SIZES as readonly number[]).includes(n))
    .optional()
    .catch(undefined),
  sort: z.string().max(40).optional().catch(undefined),
  dir: z.enum(['asc', 'desc']).optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
};

export interface ListSearch {
  page?: number | undefined;
  size?: number | undefined;
  sort?: string | undefined;
  dir?: 'asc' | 'desc' | undefined;
  q?: string | undefined;
}

export function tableState(
  s: ListSearch,
  defaults: { sort: string; dir: 'asc' | 'desc'; size?: number },
): ServerTableState {
  return {
    page: s.page ?? 1,
    pageSize: s.size ?? defaults.size ?? 25,
    sort: s.sort ?? defaults.sort,
    dir: s.dir ?? defaults.dir,
  };
}

/** Зміна стану таблиці → часткове оновлення URL (типові значення з URL прибираються). */
export function tableStateToSearch(next: Partial<ServerTableState>): Partial<ListSearch> {
  const out: Partial<ListSearch> = {};
  if ('page' in next) out.page = next.page === 1 ? undefined : next.page;
  if ('pageSize' in next) out.size = next.pageSize === 25 ? undefined : next.pageSize;
  if ('sort' in next) out.sort = next.sort;
  if ('dir' in next) out.dir = next.dir;
  return out;
}
